import { useEffect, useState } from "react";

import type { PhoneCountry } from "./types";
import { inferCountryFromLocale } from "./utils/inferCountryFromLocale";

export function useResolvedCountry(
  parsedCountry: PhoneCountry | undefined,
  mruCountry: PhoneCountry | undefined,
  defaultCountry: PhoneCountry,
): PhoneCountry {
  const [inferredCountry, setInferredCountry] = useState<
    PhoneCountry | undefined
  >();

  useEffect(() => {
    if (parsedCountry || mruCountry) return;

    let cancelled = false;
    inferCountryFromLocale().then((inferred) => {
      if (!cancelled) setInferredCountry(inferred ?? defaultCountry);
    });
    return () => {
      cancelled = true;
    };
  }, [parsedCountry, mruCountry, defaultCountry]);

  return parsedCountry ?? mruCountry ?? inferredCountry ?? defaultCountry;
}
